import React from 'react';
import s from './Stores.module.scss';
import { useNavigate } from 'react-router-dom';

interface StoreCardProps {
    avatar: string;
    store_name: string;
    id: number;
}

const StoreCard: React.FC<StoreCardProps> = ({ avatar, store_name, id }) => {
    const navigate = useNavigate();

    return (
        <div className={s.card} onClick={() => navigate(`/store-profile/${id}`)}>
            <div className={s.card_image}>
                <img src={avatar} alt={store_name} />
            </div>
            <div className={s.card_info}>
                <div className={s.card_name}>{store_name}</div>
            </div>
        </div>
    );
};

export default StoreCard;